import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-galimages',
  templateUrl: './galimages.component.html',
  styleUrls: ['./galimages.component.css']
})
export class GalimagesComponent implements OnInit {
  galimages:any[];
  constructor() { }

  ngOnInit(): void {
    this.galimages=[
      {
        id:"1",
        path:"https://via.placeholder.com/1200/FFFFFF.png",
        imagetitle:"sample 1 - white"
      },
      {
        id:"2",
        path:"https://via.placeholder.com/1200/000000.png",
        imagetitle:"sample 2 - black"
      },
      {
        id:"3",
        path:"https://via.placeholder.com/1200/FF0000/FFFFFF.png",
        imagetitle:"sample 3 - red"
      },
      
    ];
    console.log(this.galimages);
  }

}
